<a class="weatherwidget-io" href="{{url}}" data-label_1="{{label}}" data-font="Arial">{{label}} {{TR 'Wetter'}}</a>

